import React from "react";
import "./style/slider.css"
//import img from "../assets/section_cequeles/background_header.png"
import imgMob from "../assets/header_bg/bgapropos.png"

import Popup from "reactjs-popup";
import BurgerIcon from "./BurgerIcon";
import SideList from "./SideList";
import Menu from "./Menu";
import "./index.css";

const contentStyle = {
  position: "relative",
  paddingBottom: "100%",
  /*background: "linear-gradient(to right, #0c0abe , #07054c)",*/
  background: "linear-gradient(to right, #0c0abe , #07054c)",
  border: "none",
  width: "100%", 
  textAlign: "center",
  padding: "0px !important",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "80px",
};


class Slider extends React.Component {

  render() {
    return (
      <div>
        <div className="banniereSlider">
          {/*Menu horizontal Web*/}
          <div className="menu-horizontal">
            <Menu />
          </div>
          {/*Menu Responsive Popup*/}
          <div className="menuMobile">
        
              <Popup
                modal
                overlayStyle={{ background: "linear-gradient(to right, #0c0abe , #07054c)", width: "100%" }}
                contentStyle={contentStyle}
                closeOnDocumentClick={false}
                trigger={open => <BurgerIcon open={open} />}
          
              >
             
              <SideList />
              </Popup>
            
          </div>
          
          <div className="textBanniere">
            
                <h1 className="sliderTitle">La VIE, EN <br/>PLUS <b style={{ color: "#ffd904" }}>SMART</b></h1>
              
                <div><img src={imgMob} className="imageBaniereslider" alt="" /></div>
             
          </div>
        </div>
      </div>

    );
  }
}
export default Slider;


// WEBPACK FOOTER //
// ./src/home/slider.js